// extracted by mini-css-extract-plugin
module.exports = {"media":"Sign_media__VXjxx","marquee":"Sign_marquee__9svOH"};